import * as React from 'react';
import { ContactPickerPane } from 'owa-contact-picker';
import { observer } from 'mobx-react';
import { RecipientWellLabelWithContactPickerProps } from './RecipientWellLabelWithContactPicker.types';
import { RecipientWellLabel } from './RecipientWellLabel';

export interface RecipientWellLabelWithContactPickerState {
    shouldShowContactPicker: boolean;
}

@observer
export default class RecipientWellLabelWithContactPicker extends React.Component<
    RecipientWellLabelWithContactPickerProps,
    RecipientWellLabelWithContactPickerState
> {
    private contactPickerButton: HTMLElement;

    constructor(props: RecipientWellLabelWithContactPickerProps) {
        super(props);

        this.state = {
            shouldShowContactPicker: false,
        };
    }
    render() {
        let { theme, recipientType, addRecipient } = this.props;
        let wellLabel = (
            <RecipientWellLabel
                ref={this.bindContactPickerRef}
                onClick={this.showContactPicker}
                theme={theme}
                recipientType={recipientType}
            />
        );

        return (
            <>
                {wellLabel}
                {this.state.shouldShowContactPicker && (
                    <ContactPickerPane
                        findControlGetter={this.getContactPickerButton}
                        dismissContactPickerAction={this.dismissContactPicker}
                        addRecipientAction={addRecipient}
                        theme={theme}
                    />
                )}
            </>
        );
    }

    private showContactPicker = () => {
        this.setState({
            shouldShowContactPicker: !this.state.shouldShowContactPicker,
        });
    };

    private dismissContactPicker = () => {
        this.setState({ shouldShowContactPicker: false });
    };

    private bindContactPickerRef = (ref: HTMLElement) => {
        if (ref != null) {
            this.contactPickerButton = ref;
        }
    };

    private getContactPickerButton = () => {
        return this.contactPickerButton;
    };
}
